if (!customElements.get('main-search')) {
  const MainSearch = class extends HTMLElement {
    constructor() {
      super();

      this.searchInput = this.querySelector('.main-search__input');
      this.searchForm = this.searchInput
        ? this.searchInput.closest('form')
        : null;

      // Clicking close button
      this.querySelectorAll('.main-search__close').forEach((el) => {
        el.addEventListener('click', (evt) => {
          evt.preventDefault();
          document.body.classList.remove('show-search');
        });
      });

      // Pressing escape key
      if (this.searchInput) {
        this.searchInput.addEventListener('keyup', (evt) => {
          if (evt.key === 'Escape') {
            const closeButton = this.querySelector('.main-search__close');

            if (closeButton) {
              closeButton.dispatchEvent(new Event('click'));
            }
          }
        });
      }

      /**
       * NORMAL SEARCH SUBMIT
       *
       * Predictive search burada değişmiyor.
       *
       * Kullanıcı:
       * sabahlik
       *
       * Shopify'a:
       * (title:sabahlik OR body:sabahlik OR tag:sabahlik)
       *
       * gönderilir.
       */
      if (this.searchForm && this.searchInput) {
        this.searchForm.addEventListener('submit', (evt) => {
          const rawTerm = this.searchInput.value.trim();

          if (!rawTerm.length) {
            return;
          }

          evt.preventDefault();

          const searchURL = this.buildFullSearchURL(
            this.searchForm,
            rawTerm
          );

          window.location.href = searchURL.toString();
        });
      }

      // Search as you type
      if (this.dataset.quickSearch === 'true') {
        this.initQuickSearch();
      }
    }

    /**
     * Bizim ürettiğimiz kontrollü sorgu zaten input'a gelirse
     * ikinci kez dönüştürülmesini engeller.
     */
    isControlledQuery(value) {
      return (
        value.includes('title:') &&
        value.includes(' OR body:') &&
        value.includes(' OR tag:')
      );
    }

    /**
     * Shopify search syntax içerisinde problem yaratabilecek
     * temel karakterleri escape eder.
     */
    escapeSearchToken(token) {
      return token
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .replace(/\(/g, '\\(')
        .replace(/\)/g, '\\)')
        .replace(/:/g, '\\:');
    }

    /**
     * Kontrollü search query oluşturur.
     *
     * boxer
     *
     * =>
     *
     * (title:boxer OR body:boxer OR tag:boxer)
     *
     *
     * ipek sabahlık
     *
     * =>
     *
     * (title:ipek OR body:ipek OR tag:ipek)
     * AND
     * (title:sabahlık OR body:sabahlık OR tag:sabahlık)
     *
     * Böylece çok kelimeli aramada her kelimenin:
     *
     * - title
     * - description/body
     * - tag
     *
     * alanlarından en az birinde bulunması yeterlidir.
     */
    buildControlledQuery(rawTerm) {
      const cleanTerm = rawTerm
        .trim()
        .replace(/\s+/g, ' ');

      if (!cleanTerm.length) {
        return '';
      }

      if (this.isControlledQuery(cleanTerm)) {
        return cleanTerm;
      }

      const terms = cleanTerm
        .split(' ')
        .map((term) => term.trim())
        .filter(Boolean);

      return terms
        .map((term) => {
          const safeTerm = this.escapeSearchToken(term);

          return (
            `(title:${safeTerm}` +
            ` OR body:${safeTerm}` +
            ` OR tag:${safeTerm})`
          );
        })
        .join(' AND ');
    }

    /**
     * Full search URL oluşturur.
     *
     * Formdaki q dışındaki parametreleri korur.
     */
    buildFullSearchURL(form, rawTerm) {
      const searchURL = new URL(
        form.action,
        window.location.origin
      );

      const formParams = new URLSearchParams(
        new FormData(form)
      );

      formParams.forEach((value, key) => {
        if (key !== 'q') {
          searchURL.searchParams.set(key, value);
        }
      });

      // Ekim 2026: ham kelime + kelime başı eşleşmesi ("mum" → mumu, mumlu).
      // İlgisiz sonuçlar sections/main-search.liquid içinde süzülüyor.
      searchURL.searchParams.set(
        'q',
        rawTerm.trim().replace(/\s+/g, ' ')
      );

      searchURL.searchParams.set(
        'options[prefix]',
        'last'
      );

      return searchURL;
    }

    initQuickSearch() {
      const searchInput =
        this.querySelector('.main-search__input');

      const searchTimeoutThrottle = 500;
      const resultLimit = 4;

      // Ekim 2026: Öneriler Predictive API yerine arama sayfasının süzülmüş
      // sonuçlarından alınır (Predictive en fazla 10 aday veriyor, ilgisizler
      // elenince eksik kalıyordu). Böylece öneriler ile Enter sonrası aynı olur.
      const usePredictiveApi = false;

      const includeMeta =
        this.dataset.quickSearchMeta === 'true';

      let searchTimeoutID = -1;
      let searchAbortController = null;

      const handleInputChange = () => {
        const resultsBox =
          this.querySelector('.main-search__results');

        const valueToSearch =
          searchInput.value;

        // Only search if search string has content
        // and value has changed
        if (
          valueToSearch.length &&
          valueToSearch !== this.oldSearchValue
        ) {
          this.oldSearchValue =
            valueToSearch;

          // Kill outstanding ajax request
          if (searchAbortController !== null) {
            searchAbortController.abort();
            searchAbortController = null;
          }

          // Kill previous search
          clearTimeout(searchTimeoutID);

          const form =
            searchInput.closest('form');

          /**
           * "Tüm sonuçları görüntüle" linki için
           * kontrollü normal search URL'si.
           *
           * Predictive request bununla yapılmıyor.
           */
          const linkURL =
            this.buildFullSearchURL(
              form,
              valueToSearch
            );

          // Show loading
          this.classList.remove(
            'main-search--has-results',
            'main-search--results-on-multiple-lines',
            'main-search--no-results'
          );

          this.classList.add(
            'main-search--loading'
          );

          if (
            !this.querySelector(
              '.main-search__results-spinner'
            )
          ) {
            resultsBox.innerHTML =
              '<div class="main-search__results-spinner">' +
              '<div class="loading-spinner"></div>' +
              '</div>';
          }

          searchTimeoutID = setTimeout(() => {
            searchAbortController =
              new AbortController();

            let ajaxUrl;

            if (
              usePredictiveApi &&
              theme.Shopify.features.predictiveSearch
            ) {
              /**
               * IMPORTANT
               *
               * PREDICTIVE SEARCH DEĞİŞMİYOR.
               *
               * Shopify Predictive Search API'ye
               * hâlâ ham kullanıcı kelimesi gider.
               *
               * sabahlik
               * boxer
               * hediye
               *
               * Dolayısıyla mevcut predictive
               * merchandising sistemimiz korunur.
               */
              ajaxUrl = new URL(
                theme.routes.base +
                theme.routes.predictiveSearch
              );

              ajaxUrl.searchParams.set(
                'q',
                valueToSearch
              );

              ajaxUrl.searchParams.set(
                'section_id',
                'predictive-search'
              );

              // Ekim 2026: en fazla 10 aday iste (gösterilen 4), etiket ve
              // açıklamada da ara; ilgisizler predictive-search.liquid'de süzülüyor.
              ajaxUrl.searchParams.set(
                'resources[limit]',
                10
              );

              ajaxUrl.searchParams.set(
                'resources[options][fields]',
                includeMeta
                  ? 'title,product_type,variants.title,vendor,tag,body,variants.sku'
                  : 'title,product_type,variants.title,vendor,tag,body'
              );
            } else {
              /**
               * Predictive Search API olmayan
               * temalar için fallback.
               */
              ajaxUrl = new URL(
                linkURL
              );

              ajaxUrl.searchParams.set(
                'section_id',
                'main-search'
              );
            }

            fetch(ajaxUrl, {
              method: 'get',
              signal:
                searchAbortController.signal
            })
              .then((response) => {
                if (!response.ok) {
                  throw new Error(
                    `HTTP error! Status: ${response.status}`
                  );
                }

                return response.text();
              })
              .then((response) => {
                const template =
                  document.createElement(
                    'template'
                  );

                template.innerHTML =
                  response;

                let resultsList = null;

                if (
                  usePredictiveApi &&
                  theme.Shopify.features
                    .predictiveSearch
                ) {
                  resultsList =
                    template.content.querySelector(
                      '.product-grid'
                    );
                } else {
                  resultsList =
                    template.content.querySelector(
                      '.section-search-template .product-grid'
                    );
                }

                searchAbortController =
                  null;

                this.classList.remove(
                  'main-search--has-results',
                  'main-search--results-on-multiple-lines',
                  'main-search--no-results'
                );

                resultsBox.innerHTML = '';

                if (!resultsList) {
                  this.classList.remove(
                    'main-search--loading'
                  );

                  this.classList.add(
                    'main-search--no-results'
                  );

                  const emptyMessage =
                    document.createElement(
                      'div'
                    );

                  emptyMessage.className =
                    'main-search__empty-message';

                  emptyMessage.innerHTML =
                    theme.strings
                      .generalSearchNoResultsWithoutTerms;

                  resultsBox.appendChild(
                    emptyMessage
                  );

                  return;
                }

                const resultsProducts =
                  document.createElement(
                    'div'
                  );

                resultsProducts.className =
                  'main-search__results__products collection-listing';

                resultsProducts.innerHTML =
                  '<div></div>';

                const resultsPages =
                  document.createElement(
                    'div'
                  );

                resultsPages.className =
                  'main-search__results__pages';

                resultsProducts
                  .firstElementChild
                  .className =
                  resultsList.className;

                /**
                 * Convert standard blocks into
                 * quick search result format.
                 *
                 * Buradaki davranışı temanın
                 * orijinal haliyle koruyoruz.
                 */
                resultsList
                  .querySelectorAll(
                    '.product-block:not(.collection-block):not(.page-block)'
                  )
                  .forEach(
                    (block, index) => {
                      if (
                        index < resultLimit
                      ) {
                        block.classList.add(
                          'main-search-result'
                        );

                        block
                          .querySelectorAll(
                            '.btn.quickbuy-toggle'
                          )
                          .forEach(
                            (el) =>
                              el.remove()
                          );

                        block
                          .querySelectorAll(
                            '.quickbuy-toggle'
                          )
                          .forEach(
                            (el) =>
                              el.classList.remove(
                                'quickbuy-toggle'
                              )
                          );

                        resultsProducts
                          .firstElementChild
                          .appendChild(
                            block
                          );
                      }
                    }
                  );

                resultsList
                  .querySelectorAll(
                    '.product-block.page-block'
                  )
                  .forEach((block) => {
                    const item =
                      document.createElement(
                        'a'
                      );

                    item.className =
                      'main-search-result main-search-result--page';

                    item.href =
                      block.querySelector(
                        'a'
                      ).href;

                    item.innerHTML =
                      '<div class="main-search-result__text"></div>';

                    item.firstElementChild
                      .innerText =
                      block.querySelector(
                        '.page-block__title'
                      ).innerText;

                    resultsPages.appendChild(
                      item
                    );
                  });

                this.classList.remove(
                  'main-search--loading'
                );

                const areProducts =
                  !!resultsProducts.querySelector(
                    '.main-search-result'
                  );

                const arePages =
                  !!resultsPages.querySelector(
                    '.main-search-result'
                  );

                if (
                  areProducts ||
                  arePages
                ) {
                  this.classList.add(
                    'main-search--has-results'
                  );

                  this.classList.toggle(
                    'main-search--results-on-multiple-lines',
                    resultsProducts
                      .querySelectorAll(
                        '.product-block'
                      ).length > 4
                  );

                  if (areProducts) {
                    resultsBox.appendChild(
                      resultsProducts
                    );
                  }

                  if (arePages) {
                    const heading =
                      document.createElement(
                        'h6'
                      );

                    heading.className =
                      'main-search-result__heading';

                    heading.innerHTML =
                      theme.strings
                        .generalSearchPages;

                    resultsPages
                      .insertAdjacentElement(
                        'afterbegin',
                        heading
                      );

                    resultsBox.appendChild(
                      resultsPages
                    );
                  }

                  /**
                   * TÜM SONUÇLARI GÖRÜNTÜLE
                   *
                   * Predictive search ham query
                   * kullanmaya devam eder.
                   *
                   * Ama bu link kontrollü normal
                   * search URL'sine gider.
                   */
                  const allLink =
                    document.createElement(
                      'a'
                    );

                  allLink.className =
                    'main-search__results-all-link btn btn--secondary';

                  allLink.href =
                    linkURL.toString();

                  allLink.innerHTML =
                    theme.strings
                      .generalSearchViewAll;

                  resultsBox.appendChild(
                    allLink
                  );
                } else {
                  this.classList.add(
                    'main-search--no-results'
                  );

                  const emptyMessage =
                    document.createElement(
                      'div'
                    );

                  emptyMessage.className =
                    'main-search__empty-message';

                  emptyMessage.innerHTML =
                    theme.strings
                      .generalSearchNoResultsWithoutTerms;

                  resultsBox.appendChild(
                    emptyMessage
                  );
                }
              })
              .catch((error) => {
                if (
                  error.name ===
                    'AbortError' ||
                  error.code === 20
                ) {
                  return;
                }

                throw error;
              });
          }, searchTimeoutThrottle);
        } else if (
          !valueToSearch.length
        ) {
          this.oldSearchValue =
            valueToSearch;

          if (
            searchAbortController !==
            null
          ) {
            searchAbortController.abort();
            searchAbortController =
              null;
          }

          clearTimeout(
            searchTimeoutID
          );

          this.classList.remove(
            'main-search--has-results',
            'main-search--results-on-multiple-lines',
            'main-search--loading'
          );

          resultsBox.innerHTML = '';
        }
      };

      searchInput.addEventListener(
        'keyup',
        handleInputChange.bind(this)
      );

      searchInput.addEventListener(
        'change',
        handleInputChange.bind(this)
      );
    }
  };

  window.customElements.define(
    'main-search',
    MainSearch
  );
}